"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var unwrapBlockquote_1 = __importDefault(require("./unwrapBlockquote"));
exports.unwrapBlockquote = unwrapBlockquote_1.default;
var wrapInBlockquote_1 = __importDefault(require("./wrapInBlockquote"));
exports.wrapInBlockquote = wrapInBlockquote_1.default;
//# sourceMappingURL=index.js.map